// SEO data for the website
export const seoData = {
  site: {
    name: 'A11y Services',
    url: 'https://a11yservices.com',
    description: 'Professional web accessibility consulting and WCAG compliance services',
    keywords: [
      'web accessibility',
      'WCAG compliance',
      'accessibility audit',
      'accessibility consulting',
      'Section 508',
      'ADA compliance',
      'accessibility testing',
      'inclusive design',
      'disability access',
      'accessibility remediation',
      'WCAG 2.1 AA',
      'accessibility training',
      'digital accessibility',
      'website accessibility',
      'accessibility services'
    ]
  },
  
  services: [
    {
      name: 'Accessibility Audits',
      description: 'Comprehensive WCAG 2.1 AA compliance audits with detailed reports and actionable recommendations',
      keywords: ['accessibility audit', 'WCAG audit', 'compliance testing', 'accessibility evaluation']
    },
    {
      name: 'Remediation Services',
      description: 'Expert implementation of accessibility fixes and inclusive design improvements',
      keywords: ['accessibility remediation', 'accessibility fixes', 'inclusive design', 'accessibility implementation']
    },
    {
      name: 'Training & Consulting',
      description: 'Custom accessibility training programs and ongoing consultation for development teams',
      keywords: ['accessibility training', 'accessibility consulting', 'WCAG training', 'inclusive development']
    }
  ],

  faq: [
    {
      question: 'What is WCAG compliance?',
      answer: 'WCAG (Web Content Accessibility Guidelines) compliance ensures your website meets international standards for accessibility, making it usable by people with disabilities.'
    },
    {
      question: 'Why is web accessibility important?',
      answer: 'Web accessibility ensures equal access to information and functionality for all users, including the 1+ billion people worldwide with disabilities. It also improves SEO and user experience for everyone.'
    },
    {
      question: 'How long does an accessibility audit take?',
      answer: 'Accessibility audits typically take 1-3 weeks depending on the size and complexity of your website or application.'
    },
    {
      question: 'What accessibility standards do you follow?',
      answer: 'We follow WCAG 2.1 AA standards, Section 508 compliance, and ADA requirements to ensure comprehensive accessibility coverage.'
    }
  ]
};

// Generate structured data for FAQ
export const generateFAQStructuredData = () => {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": seoData.faq.map(item => ({
      "@type": "Question",
      "name": item.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": item.answer
      }
    }))
  };
};

// Generate structured data for services
export const generateServiceStructuredData = () => {
  return {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "A11y Services",
    "url": "https://a11yservices.com",
    "description": "Professional web accessibility consulting and WCAG compliance services",
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Accessibility Services",
      "itemListElement": seoData.services.map((service, index) => ({
        "@type": "Offer",
        "position": index + 1,
        "itemOffered": {
          "@type": "Service",
          "name": service.name,
          "description": service.description
        }
      }))
    }
  };
};